import PicklistMetadata from "../PicklistMetadata";

class ProjectPlanPhaseStatusPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseStatus";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Project Plan Phase Status";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ProjectPlanPhaseStatusPicklistMetadata;
